<div
  class="flex flex-col justify-start items-stretch app-full-height px-4 pt-4"
>
  <h1>Account Transfer Report</h1>

  <form [formGroup]="reportForm" (ngSubmit)="getXeroJobs()" #formContainer>
    <div
      class="flex flex-col md:flex-row justify-start items-stretch md:items-center md:space-x-4 md:space-y-0 space-y-2 w-full"
    >
      <mat-form-field class="basis-full">
        <mat-label>Type</mat-label>
        <mat-select placeholder="Type" formControlName="type">
          <mat-option [value]="null"></mat-option>
          <mat-option value="docket">Hire Invoice</mat-option>
          <mat-option value="payment">Payment</mat-option>
          <mat-option value="repairDocket">Repair Invoice</mat-option>
          <mat-option value="saleDocket">Sale Invoice</mat-option>
          <mat-option value="retailProduct">Retail Product</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="basis-full">
        <mat-label>Result</mat-label>
        <mat-select placeholder="Status" formControlName="status">
          <mat-option [value]="null"></mat-option>
          <mat-option value="Success">Success</mat-option>
          <mat-option value="Error">Failed (non Xero)</mat-option>
          <mat-option value="Xero Errors">Xero Errors</mat-option>
          <mat-option value="Pending">Pending</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="from-to-date basis-full">
        <mat-label>Created after</mat-label>
        <input
          matInput
          [matDatepicker]="fromPicker"
          formControlName="from"
          placeholder="From date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="fromPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="from-to-date basis-full">
        <mat-label>Created before</mat-label>
        <input
          matInput
          [matDatepicker]="toPicker"
          formControlName="to"
          placeholder="To date"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="toPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
      <div class="flex md:basis-full md:flex-shrink md:flex-row justify-end">
        <button
          mat-raised-button
          color="primary"
          class="mb-6"
          [disabled]="!reportForm.valid"
        >
          Generate
        </button>
      </div>
    </div>
  </form>

  <div class="flex flex-row basis-full flex-grow min-h-[400px]">
    <ag-grid-angular
      #agGrid
      class="flex-grow h-full"
      [ngStyle]="{ 'height.%': 100, 'width.%': '100' }"
      class="ag-theme-alpine"
      [columnDefs]="columns"
      enableColResize
      enableSorting
      [gridOptions]="gridOptions"
    ></ag-grid-angular>
  </div>
</div>
